import React, { useState, VFC, FocusEvent, ChangeEvent } from "react";

import { ValueFieldProps } from "@sitecore-jss/sitecore-jss-react-forms/types";
import { StringInputViewModel } from "@sitecore-jss/sitecore-jss-forms";

const PasswordField: VFC<ValueFieldProps<StringInputViewModel>> = (props) => {
  const { field, tracker } = props;
  const [hasFocus, setHasFocus] = useState(false);
  const [hasVisiblePassword, setHasVisiblePassword] = useState(false);
  const [value, setValue] = useState(props.value);
  const hasValueOrFocus = hasFocus || value !== "";
  const hasAnyError = !!props.errors?.length;
  const id = field.valueField.id;
  const label = field.model.title;
  const name = field.valueField.name;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;

  const onFocus = (e: FocusEvent<HTMLInputElement>) => {
    tracker.onFocusField(field, e.target.value);
    setHasFocus(true);
  };

  const onBlur = (e: FocusEvent<HTMLInputElement>) => {
    tracker.onBlurField(field, e.target.value);
    setHasFocus(false);
  };

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    props.onChange(field.valueField.name, e.target.value, props.isValid, []);
  };

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box ${
        hasAnyError ? "sitecore-jss-form__control--has-error" : ""
      }`}
    >
      <label
        htmlFor={id}
        className={`sitecore-jss-form__label ${
          hasValueOrFocus ? "sitecore-jss-form__label--has-focus" : ""
        }`}
      >
        {label}
      </label>
      <input
        id={id}
        name={name}
        className="sitecore-jss-form__field"
        type={`${hasVisiblePassword ? "text" : "password"}`}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        value={props.value}
      />
      <button
        type="button"
        className="sitecore-jss-form__toggle-password-visibility-btn"
        onClick={() => setHasVisiblePassword(!hasVisiblePassword)}
      >
        {hasVisiblePassword ? (
          <pfe-icon icon="ivg-eye-off-line" size="24"></pfe-icon>
        ) : (
          <pfe-icon icon="ivg-eye-line" size="24"></pfe-icon>
        )}
      </button>
      <FieldValidationErrors {...props} />
    </div>
  );
};

export default PasswordField;
